<div class="container-fluid">
  <ul class="simple-list sideways-list stack-mobile" style="margin-top: 0">
    <li class="wl-give-calendar-right-padding">
      <label for="sentSearchDateDateAndTimeToSendAfter" class="light-text wl-calendar-label">
        {{ 'communications.message-label.send-date-after' | translate | titlecase }}
      </label>
      <wl-date-selector name="sentSearchDateDateAndTimeToSendAfter" [(ngModel)]="searchParams.DateAndTimeToSendAfter"></wl-date-selector>
    </li>
    <li class="wl-give-calendar-right-padding">
      <label for="sentSearchDateAndTimeToSendBefore" class="light-text wl-calendar-label">
        {{ 'communications.message-label.send-date-before' | translate | titlecase }}
      </label>
      <wl-date-selector name="sentSearchDateAndTimeToSendBefore" [(ngModel)]="searchParams.DateAndTimeToSendBefore"></wl-date-selector>
    </li>
    <li>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary tall"
        [disabled]="isSearching || isBusy"
        (click)="startSearch()"
        [icon]="!isSearching ? 'pi pi-search' : ''"
        [label]="isSearching ? ('common.searching' | translate | titlecase) : ('common.search' | translate | titlecase)"
      >
        <wl-busy [show]="isSearching"></wl-busy>
      </button>
    </li>
  </ul>
  <p-table [showGridlines]="true"
    #sentGrid
    [rows]="20"
    styleClass="wl-responsive-prime-datatable"
    [value]="sentResult.Result"
    [paginator]="true"
    (onLazyLoad)="lazyLoadSentMessages($event)"
    [totalRecords]="sentResult.TotalCount"
    sortField="DateAndTimeToSend"
    [sortOrder]="-1"
    [lazy]="true"
    [loading]="isSearching"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <p-button
        icon="pi pi-sort-alt"
        [rounded]="true"
        [text]="true"
        *ngIf="sortOrder === 0"
        aria-hidden="true"
        styleClass="wl-prime-datatable-column-advanced-sort-btn"
      />
      <p-button
        icon="pi pi-sort-amount-up-alt"
        [rounded]="true"
        [text]="true"
        *ngIf="sortOrder === 1"
        aria-hidden="true"
        styleClass="wl-prime-datatable-column-advanced-sort-btn"
      />
      <p-button
        icon="pi pi-sort-amount-down"
        [rounded]="true"
        [text]="true"
        *ngIf="sortOrder === -1"
        aria-hidden="true"
        styleClass="wl-prime-datatable-column-advanced-sort-btn"
      />
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th [pSortableColumn]="'Subject'" class="wl-prime-datatable-column-advanced-filter">
          <p>
            {{ 'communications.message-label.subject' | translate | titlecase }}
            <span *ngIf="searchParams.Subject" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-sortIcon field="Subject" />
            <p-columnFilter
              type="text"
              field="Subject"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Subject has', value: 'contains' }]"
              [matchMode]="'contains'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <input type="text" pInputText [(ngModel)]="searchParams.Subject" (change)="filter($event.value)" />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th [pSortableColumn]="'DateAndTimeToSend'" class="wl-prime-datatable-column-advanced-filter wl-prime-datatable-hidden-phone">
          <p>
            {{ 'communications.message-label.send-date' | translate | titlecase }}
            <span *ngIf="searchParams.DateAndTimeToSend" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-sortIcon field="DateAndTimeToSend" />
            <p-columnFilter
              field="DateAndTimeToSend"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Send date on', value: 'dateIs' }]"
              [matchMode]="'dateIs'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <p-datepicker
                  [placeholder]="'communications.message-label.filter-by-next-send-date' | translate | ucfirst"
                  [(ngModel)]="searchParams.DateAndTimeToSend"
                  [showButtonBar]="true"
                  (change)="filter($event.value)"
                ></p-datepicker>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th class="wl-prime-datatable-column-advanced-filter wl-prime-datatable-hidden-phone">
          <p>
            {{ 'communications.message-label.send-from' | translate | titlecase }}
            <span *ngIf="searchParams.SendFrom" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-columnFilter
              type="text"
              field="SendFrom"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Sender has', value: 'contains' }]"
              [matchMode]="'contains'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <input type="text" pInputText [(ngModel)]="searchParams.SendFrom" (change)="filter($event.value)" />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th class="wl-prime-datatable-column-advanced-filter wl-prime-datatable-hidden-phone">
          <p>
            {{ 'communications.message-label.count' | translate | titlecase }}
            <span *ngIf="searchParams.Count" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-columnFilter
              type="numeric"
              field="Count"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Count is', value: 'equal' }]"
              [matchMode]="'equal'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <p-inputNumber [(ngModel)]="searchParams.Count" (change)="filter($event.value)" />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th class="wl-prime-datatable-hidden-phone">
          {{ 'communications.message-label.open-rate' | translate | titlecase }}
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template let-message pTemplate="body">
      <tr>
        <td>
          <div style="overflow: hidden">
            <a [routerLink]="['/communications/message', message.MessageId]">{{ message.Subject }}</a>
          </div>
          <div class="wl-prime-datatable-hidden-tablet-and-bigger">
            <div>
              <strong>{{ 'communications.message-label.date-created' | translate | titlecase }}: </strong> {{ message.DateCreated }}
            </div>
            <p>
              <strong>{{ 'communications.message-label.send-date' | translate | titlecase }}: </strong>
              {{ message.DateAndTimeToSend | date: 'shortDate' }} {{ message.DateAndTimeToSend | date: 'shortTime' }}
              {{ localTimeZoneAbbreviation }}
            </p>
            <p>
              <strong>{{ 'communications.message-label.count' | translate | titlecase }}: </strong> {{ message.CommunicationsCount }}
            </p>

            <button
              type="button"
              [disabled]="isSearching || isBusy || message?.EventId > 0"
              class="atlas-btn btn-sm atlas-btn-default"
              (click)="copyMessage(message)"
              [title]="
                message?.EventId > 0
                  ? ('communications.mass-comm-message-admin.message-can-not-be-copied-because-its-from-an-event' | translate | ucfirst)
                  : ('common.copy' | translate | titlecase)
              "
            >
              <span class="pi pi-copy"></span>
            </button>
          </div>
        </td>
        <td class="wl-prime-datatable-hidden-phone">
          {{ message.DateAndTimeToSend | date: 'shortDate' }} {{ message.DateAndTimeToSend | date: 'shortTime' }}
          {{ localTimeZoneAbbreviation }}
        </td>
        <td class="wl-prime-datatable-hidden-phone">{{ message.SendFrom }}</td>
        <td class="wl-prime-datatable-hidden-phone">{{ message.CommunicationsCount }}</td>
        <td class="wl-prime-datatable-hidden-phone">{{ message.OpenRate | atlasPercent }}</td>
        <td class="wl-prime-datatable-hidden-phone">
          <button
            type="button"
            [disabled]="isSearching || isBusy || message?.EventId > 0"
            class="atlas-btn atlas-btn-default"
            (click)="copyMessage(message)"
            [title]="
              message?.EventId > 0
                ? ('communications.mass-comm-message-admin.message-can-not-be-copied-because-its-from-an-event' | translate | ucfirst)
                : ('common.copy' | translate | titlecase)
            "
          >
            <span class="pi pi-copy"></span>
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center">
          {{ 'communications.mass-comm-message-admin.no-sent' | translate | titlecase }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  #deleteSentMessageConfirmationModal
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <p>{{ 'communications.mass-comm-message-admin.message-delete-confirmation-prompt' | translate }}</p>
  <ng-template pTemplate="footer">
    <wl-busy [show]="deleting"></wl-busy>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-danger"
      (click)="deleteMessgeConfirmed()"
      [disabled]="deleting"
      icon="pi pi-trash"
      [label]="deleting ? ('common.deleting' | translate | titlecase) : ('common.delete' | translate | titlecase)"
    ></button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="this.showModal = false"
      [disabled]="deleting"
      icon="pi pi-ban"
      [label]="'common.cancel' | translate | titlecase"
    ></button>
  </ng-template>
</p-dialog>
